import React from 'react';
import {Button, Descriptions, Flex, Space} from 'antd';
import {useModel} from "@@/exports";
import {SyncOutlined} from "@ant-design/icons";
import {RobotStatusMap} from "@/components/AiComponent/Interface/RobotInterface";

const ActionRender = (props) => {
  const {robot} = props;
  const {setRobot} = useModel('copilot');

  return (
    <Space>
      <Descriptions column={1}>
        <Descriptions.Item label={'当前机器人'}>
          {robot?.name}
        </Descriptions.Item>
        <Descriptions.Item label={'状态'}>
          {RobotStatusMap[robot?.status]}
        </Descriptions.Item>
      </Descriptions>
    </Space>
  );
};
export default ActionRender;
